// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desc {
  padding: 1rem;
  display: flex;
  justify-content: center;
  text-decoration: underline;
}

.cell-separator {
  border-right: 1px solid rgba(224, 224, 224, 1) !important;
}

.title-dialog {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.cell-error {
  color: #cc0000 !important;
  font-weight: bold !important;
}

.font-bold {
  font-weight: bold !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/ArchivosSalvta/ConciliationModal/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".desc {\n  padding: 1rem;\n  display: flex;\n  justify-content: center;\n  text-decoration: underline;\n}\n\n.cell-separator {\n  border-right: 1px solid rgba(224, 224, 224, 1) !important;\n}\n\n.title-dialog {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.cell-error {\n  color: #cc0000 !important;\n  font-weight: bold !important;\n}\n\n.font-bold {\n  font-weight: bold !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
